<template>
    <div  style="height: 100% !important">
        <h1>{{ transl["STR_TITLE_STATS"]}}</h1>

        <div class="developer" v-if="this.$store.getters.developer">
            <b>Entwickler Ausgabe:</b>
            <pre v-html="this.$store.getters.getApoStats"></pre>
        </div>
        <div class="boxes">
            <div class="box">
                <div class="number">
                    {{ this.$store.getters.cyclers.length }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_DEVICES"]}}
                </div>
            </div>

            <div class="box">
                <div class="number">
                    {{ this.$store.getters.cyclers.filter(e => e.state == 1).length }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_BUSYDEVICES"]}}
                </div>
            </div>            

            <div class="box">
                <div class="number">
                    {{ this.$store.getters.tests.length }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_SUMTESTS"]}}
                </div>
            </div>

            <div class="box">
                <div class="number">
                    {{ this.$store.getters.getApoStats.probes_total }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_SUMPROBES"] }}
                </div>
            </div>

            <div class="box">
                <div class="number">
                    {{ this.$store.getters.getApoStats.total_positive }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_SUMPOSITIVES"]}}
                </div>
            </div>

            <div class="box">
                <div class="number">
                    {{ this.$store.getters.getApoStats.total_invalids }}
                </div>
                <div class="text">
                    {{ transl["STR_STATS_SUMINVALIDS"] }}
                </div>
            </div>

            <div class="box">
                <div class="number">
                    {{ (this.$store.getters.getApoStats.total_positive*100/this.$store.getters.getApoStats.probes_total).toFixed(1) }}%
                </div>
                <div class="text">
                    {{ transl["STR_STATS_QUOTE"]}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default ({
    props: [ 'transl' ],
    setup() {
        
    },
})
</script>
